import React from 'react'
import { Button } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'

const MenuButton = ({
  children, text, onClick, enabled
}) => (
  <Button variant="tertiary" className="c-button-menu__item--fill" onClick={onClick} disabled={!enabled}>
    <svg height="80%" viewBox="0 0 200 200">
      <g fill="none" fillRule="evenodd">
        <circle cx="100" cy="100" stroke={enabled ? '#f06c00' : '#8e8e8e'} r="95" strokeWidth="4%" />
        {children}
      </g>
    </svg>
    {text !== '' && <span style={{ color: enabled ? '#f06c00' : '#8e8e8e' }}>{text}</span>}
  </Button>
)

MenuButton.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired
}

MenuButton.defaultProps = {
  text: ''
}

export default MenuButton
